// Site-schakelaar, ALLEEN zichtbaar bij meerdere installaties: met één
// site rendert dit null en blijft het scherm exact zoals het was. De
// KEUZE staat in localStorage, de TOEGANG in het ondertekende token:
// een site buiten het token geeft 403 bij de backend, dus dit menu
// levert nooit meer rechten op dan de login heeft.
// docs/customer-app.md > Meerdere installaties onder één login
import { useEffect, useState } from "react";
import { fetchMySites, getActiveSite, setActiveSite, type SiteChoice } from "../api";

export function SiteSwitcher() {
  const [sites, setSites] = useState<SiteChoice[] | null>(null);
  const [active, setActive] = useState<string>(getActiveSite());

  useEffect(() => {
    let alive = true;
    fetchMySites()
      .then((list) => {
        if (!alive) return;
        setSites(list);
        // Eerste keer (of na een wijziging in de toegang): val terug op
        // de standaardsite, zodat een opgeslagen keuze naar een site
        // die je niet meer mag geen 403-muur oplevert.
        const known = list.some((s) => s.id === active);
        if (!known) {
          const def = list.find((s) => s.is_default) ?? list[0];
          if (def) {
            setActiveSite(def.id);
            setActive(def.id);
          }
        }
      })
      .catch(() => setSites([]));
    return () => {
      alive = false;
    };
    // bewust één keer: de toegangslijst verandert alleen bij opnieuw inloggen
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!sites || sites.length < 2) return null;

  function pick(id: string) {
    if (id === active) return;
    setActiveSite(id);
    setActive(id);
    // Alle schermen halen hun data bij het monteren op; een harde
    // reload is hier eerlijker dan tientallen losse refetches - en
    // voorkomt dat één achtergebleven scherm nog cijfers van de vorige
    // installatie toont.
    window.location.reload();
  }

  return (
    <div className="px-4 pt-3 lg:px-8 lg:pt-6 lg:max-w-sm">
      <label className="sr-only" htmlFor="site-switcher">
        Installatie
      </label>
      <select
        id="site-switcher"
        className="w-full rounded-lg border border-line bg-card px-3 py-2 text-sm text-ink"
        value={active}
        onChange={(e) => pick(e.target.value)}
      >
        {sites.map((s) => (
          <option key={s.id} value={s.id}>
            {s.name || s.id}
          </option>
        ))}
      </select>
    </div>
  );
}
